import { Component, Input } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-date-time-input',
  standalone: true,
  imports: [ReactiveFormsModule, NgbDatepickerModule],
  templateUrl: './date-time-input.component.html',
  styleUrl: './date-time-input.component.scss'
})
export class DateTimeInputComponent {
  @Input({ required: true }) control!: AbstractControl | null;
  @Input() inputId = '';
  @Input() mode: 'date' | 'datetime' = 'date';
  @Input() readonly = false;
  @Input() placeholder = '';
  @Input() openCalendarLabel = 'เปิดปฏิทิน';
  @Input() size: 'sm' | 'md' = 'md';
}
